import React from 'react';
import PropTypes from 'prop-types';
import { createHashHistory } from 'history';
import { Nav, NavItem, NavLink, Container, Row, Col, Card, CardBody } from 'reactstrap';
import { hasAdminSubSectionPermission } from '../../../utils/paths';
const hashHistory = createHashHistory();
const OrganizationContainer = _ref => {
  let _ref$children = _ref.children,
    children = _ref$children === void 0 ? undefined : _ref$children,
    section = _ref.section,
    id = _ref.id;
  const handleSelect = key => hashHistory.replace("/admin/organizations/".concat(id, "/").concat(key));
  const header = /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement("h3", null, "Organization Sections")));
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardBody, {
    className: "card-heading"
  }, header), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Nav, {
    pills: true,
    vertical: true
  }, hasAdminSubSectionPermission('organizations_general') ? /*#__PURE__*/React.createElement(NavItem, {
    className: "t-oc-nav-section-general",
    active: section.length > 0 ? section === 'general' : true
  }, /*#__PURE__*/React.createElement(NavLink, {
    onClick: () => handleSelect('general')
  }, "General")) : undefined, hasAdminSubSectionPermission('organizations_general') ? /*#__PURE__*/React.createElement(NavItem, {
    className: "t-oc-nav-section-contition-costs",
    active: section.length > 0 ? section === 'condCost' : true
  }, /*#__PURE__*/React.createElement(NavLink, {
    onClick: () => handleSelect('condCost')
  }, "Condition Costs")) : undefined)))), /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, children)));
};
OrganizationContainer.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired
};
export default OrganizationContainer;